import "./nav-bar.styles.css"
const NavBar = (props) => {
    return (
        <div>
            <div className="nav-bar"></div>
        </div>
        
    )
}
export default NavBar;